import { Injectable } from '@angular/core';
import { UrlConfigContainer } from '@admin/core/url-config';
import { UrlConfigService } from '@hrra/core';
import { AjaxDataServiceService } from '@admin/core/ajax-data-service.service';
import { ThreadRelatedObjectType } from '@admin/shared/models/comment-models/thread-related-object-type.enum';
import { ThreadWithPreviewsModel } from '@admin/shared/models/comment-models/thread-with-previews-model';
import { PostingChannel } from '../models/comment-models/posting-channel.enum';
import { ActionResultModel } from '../models/action-result-model';
import { ThreadTopic } from '@admin/shared/models/comment-models/thread-topic.enum';
import { ThreadPostModel } from '../models/comment-models/thread-post-model';

@Injectable({
  providedIn: 'root',
})
export class CommentsService {
  constructor(
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {}

  public FilterThreadPreviews(
    objectTypeId: ThreadRelatedObjectType,
    objectIdList: number[]
  ) {
    let data = {
      objectTypeId: objectTypeId,
      objectIdList: objectIdList,
    };
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.comments.FilterThreadsWithPreview,
      data,
      ThreadWithPreviewsModel
    );
  }

  public FilterThreadComments(threadId: number, offset: number, take: number) {
    let data = { threadId, offset, take };
    return this.ajax.getDataPaging(
      this.urlService.urlConfig.api.data.comments.FilterThreadComments,
      data,
      ThreadPostModel
    );
  }

  public AddCommentToThread(
    threadId: number,
    channelId: PostingChannel,
    text: string,
    replyTargetId: number = null
  ) {
    let data = {
      threadId,
      channelId,
      text,
      replyTargetId,
    };
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.comments.AddCommentToThread,
      data,
      ActionResultModel
    );
  }

  public AddCommentForObject(
    objectTypeId: ThreadRelatedObjectType,
    objectId: number,
    topicId: ThreadTopic,
    channelId: PostingChannel,
    text: string,
    replyTargetId: number = null
  ) {
    let data = {
      objectTypeId,
      objectId,
      topicId,
      channelId,
      text,
      replyTargetId,
    };
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.comments.AddComment,
      data,
      ActionResultModel
    );
  }

  public DeleteComment(commentId: number) {
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.comments.DeleteComment,
      { commentId },
      ActionResultModel
    );
  }
}
